import { render } from "./CruResourceFooter.vue?vue&type=template&id=f5714402"
import script from "./CruResourceFooter.vue?vue&type=script&lang=js"
export * from "./CruResourceFooter.vue?vue&type=script&lang=js"

import "./CruResourceFooter.vue?vue&type=style&index=0&id=f5714402&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__